import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const formatPct = (pct) => {
  if (pct == null || isNaN(pct)) return '—';
  return `${pct.toFixed(1)}%`;
};

const SHOT_KEY = { T2: 't2', T3: 't3', TL: 'ft' };

const SingleBadge = ({ label, current }) => {
  const { t } = useTranslation();

  if (!current) return null;

  const shot = current[SHOT_KEY[label]];
  if (!shot) return null;

  const compPart = current.competition_name ? ` (${current.competition_name})` : '';
  const header = t('playerProfile.shootingBadges.tooltipTitle', {
    label,
    season: current.season_year || '',
    competition: compPart
  });

  const tooltipContent = (
    <Box>
      <Typography variant="caption" sx={{ display: 'block', fontWeight: 'bold' }}>
        {header}
      </Typography>
      {shot.made != null && shot.att != null ? (
        <Typography variant="caption" sx={{ display: 'block' }}>
          {t('playerProfile.shootingBadges.tooltipVolume', {
            made: shot.made,
            att: shot.att,
            points: shot.points
          })}
        </Typography>
      ) : (
        <Typography variant="caption" sx={{ display: 'block', fontStyle: 'italic' }}>
          {t('playerProfile.shootingBadges.tooltipNoVolume')}
        </Typography>
      )}
    </Box>
  );

  return (
    <Tooltip arrow title={tooltipContent}>
      <Box
        sx={{
          backgroundColor: '#f5f5f5',
          borderRadius: 1,
          px: 1,
          py: 0.25,
          minWidth: 56,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          cursor: 'default'
        }}
      >
        <Typography
          variant="caption"
          sx={{ fontSize: '0.6rem', color: '#666', lineHeight: 1, fontWeight: 'bold' }}
        >
          {label}
        </Typography>
        <Typography
          variant="caption"
          sx={{ fontSize: '0.85rem', fontWeight: 'bold', lineHeight: 1.1, color: '#000' }}
        >
          {formatPct(shot.pct)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

const ShootingBadges = ({ data }) => {
  if (!data || !data.current) return null;
  const { current } = data;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.75, mt: 1, mb: 1 }}>
      <SingleBadge label="T2" current={current} />
      <SingleBadge label="T3" current={current} />
      <SingleBadge label="TL" current={current} />
    </Box>
  );
};

export default ShootingBadges;
